exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/~/core-js/modules/_wks-ext.js
// module id = ../../../../core-js/modules/_wks-ext.js
// module chunks = 1